module.exports = __webpack_public_path__ + "static/img/33.b218a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/33.png
// module id = 4afe
// module chunks = 1